import React from 'react';
import { ConfiguableSvgProps } from './types';

const LosersIcon = ({
	width = '16',
	height = '16',
	...props
}: ConfiguableSvgProps) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M5.33333 12H12V5.33333M12 12L4 4L12 12Z"
				stroke={props.color}
				strokeWidth="1.33333"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default LosersIcon;
